import config from "../../../../config";
import * as modules from "./modules/";
const { vendor } = config;

const ManualStrategyPage = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default ManualStrategyPage;
